import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { DARIO_ASCANIO_ANCHOR_SRC } from '../brandAssets';

const ANCHOR_IMAGE = DARIO_ASCANIO_ANCHOR_SRC;

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Comercio Corporativo: economía, gestión y éxito empresarial
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio de TNO Network para coyuntura económica, liderazgo consciente, negociación estratégica y casos de éxito con rigor y cercanía.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Comercio Corporativo?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/comerciocorporativo"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/comerciocorporativo
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa de entrevistas con <strong>Darío Ascanio</strong>: líderes, gestión comercial, finanzas y
          alianzas que mueven el sector empresarial. <strong>Lunes 10:00 AM</strong> (Venezuela) en vivo, On-Demand
          y TNO Digest.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Darío Ascanio - Ancla de Comercio Corporativo"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRO ANCLA: DARÍO ASCANIO
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              Periodista y conductor · economía, negocios y gestión empresarial
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Darío Ascanio</strong> conduce <strong>Comercio Corporativo</strong> en TNO Network: entrevistas
              con ejecutivos, gremios y emprendedores; análisis de coyuntura y herramientas para optimizar la gestión
              comercial sin sacrificar el equilibrio corporativo. Ideal para bancos, seguros, franquicias, tecnología
              B2B y marcas que hablan a tomadores de decisión.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
